module.exports = __webpack_public_path__ + "media/newstyle/images/logo-rakuten-color-08364e764438f48ec4b9926983ad4bca.png";